import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { GroupInput } from "../../../components/Form/GroupInput";
import { Input } from "../../../components/Form/Input";
import { InputCheckboxV2 } from "../../../components/Form/InputCheckboxV2";
import { Select } from "../../../components/Form/Select";
import { PanelFilter } from "../../../components/panel/PanelFilter";
import { FieldProps } from "../../../components/panel/table/TableContent";
import {
  Order,
  OrderFilterOptions,
  OrderFilters,
} from "../../../hook/queries/useOrdersV2";
import { useOrderPages } from "../../../hook/useOrdersPage";
import { setQueryParams, useQueryParams } from "../../../hook/useQueryParams";
import { objectToForEach } from "../../../utils/objectToForEach";
import { setFormikValues } from "../../../utils/setFormikValues";

type FilterProps = {
  setViewFilter: React.Dispatch<React.SetStateAction<boolean>>;
  viewFilter: boolean;
  formikFilter: any;

  columns: FieldProps<Order>[];
  filtersData?: OrderFilterOptions;

  filters: OrderFilters;
  setFilters: (data: OrderFilters) => void;

  onUpdateData: () => void;

  is_admin?: boolean;
  is_client?: boolean;
  is_seller?: boolean;
  is_manager?: boolean;
};

export const OrderFilter = ({
  formikFilter,
  columns,
  filters,
  setFilters,
  is_client = false,
  onUpdateData,
  setViewFilter,
  viewFilter,
  filtersData,
}: FilterProps) => {
  const query = useQueryParams();
  const history = useHistory();
  const { tab } = useOrderPages();

  useEffect(() => {
    objectToForEach(filters, (key, value) => {
      if (value) {
        setQueryParams({
          data: {
            field: String(key),
            value: String(value),
          },
          type: "set",
          history,
        });
      } else {
        setQueryParams({
          data: {
            field: String(key),
          },
          type: "delete",
          history,
        });
      }
    });

    setFormikValues(filters, formikFilter);
    // eslint-disable-next-line
  }, [filters]);

  useEffect(() => {
    let filtersValueQueryParams = {};
    query.forEach((value, key) => {
      const findOne = columns.find((f) => f.name === key);

      if (findOne) {
        filtersValueQueryParams = {
          ...filtersValueQueryParams,
          [key]: value,
        };
      }
    });

    setFormikValues(filtersValueQueryParams, formikFilter);
    // eslint-disable-next-line
  }, []);

  function selectDescription(st: any, title: string) {
    let data = String(st);
    const arrTitle = [
      "brand",
      "status",
      "pointed",
      "refuse",
      "orderPeriod",
      "billingOrderPeriod",
      "orderPresetDate",
      "billingOrderPresetDate",
    ];
    if (arrTitle.includes(title)) {
      switch (title) {
        case "brand":
          const findBrand = filtersData?.brands.find(
            (brand) => Number(brand.id) === Number(st)
          );
          if (findBrand) data = findBrand.name;
          break;
        // case "status":
        //   const findStatus = filtersData?.status.find(
        //     (status) => status.id === st
        //   );
        //   if (findStatus) data = findStatus.name;
        //   break;
        // case "pointed":
        //   const findPointed = filterOptions.pointeds.find(
        //     (pointed) => Number(pointed.id) === Number(st)
        //   );
        //   if (findPointed) data = findPointed.name;
        //   break;
        // case "refuse":
        //   const findRefuse = filterOptions.refuses.find(
        //     (pointed) => Number(pointed.id) === Number(st)
        //   );
        //   if (findRefuse) data = findRefuse.name;
        //   break;
        case "billingOrderPeriod":
          if (Number(st) === 1) {
            data = "Predefinida";
          }
          if (Number(st) === 2) {
            data = "Específica";
          }
          if (Number(st) === 3) {
            data = "Intevalo";
          }
          break;
        case "orderPeriod":
          if (Number(st) === 1) {
            data = "Predefinida";
          }
          if (Number(st) === 2) {
            data = "Específica";
          }
          if (Number(st) === 3) {
            data = "Intevalo";
          }
          break;
        case "orderPresetDate":
          if (Number(st) === 0) {
            data = "Hoje";
          }
          if (Number(st) === 2) {
            data = "Ontem";
          }
          if (Number(st) === 7) {
            data = "Últimos 7 dias";
          }
          if (Number(st) === 15) {
            data = "Últimos 15 dias";
          }
          if (Number(st) === 30) {
            data = "Últimos 30 dias";
          }
          break;
        case "billingOrderPresetDate":
          if (Number(st) === 0) {
            data = "Hoje";
          }
          if (Number(st) === 2) {
            data = "Ontem";
          }
          if (Number(st) === 7) {
            data = "Últimos 7 dias";
          }
          if (Number(st) === 15) {
            data = "Últimos 15 dias";
          }
          if (Number(st) === 30) {
            data = "Últimos 30 dias";
          }
          break;
        default:
          break;
      }
    }

    return data;
  }

  return (
    <PanelFilter
      filters={filters}
      setFilters={setFilters}
      onUpdate={onUpdateData}
      columns={columns}
      onSubmit={formikFilter.handleSubmit}
      onResetForm={() => {
        formikFilter.resetForm();
        onUpdateData();
      }}
      setViewFilter={setViewFilter}
      viewFilter={viewFilter}
      normalizedFilters={selectDescription}
    >
      <GroupInput>
        <Input
          label="CÓDIGO DO PEDIDO"
          {...formikFilter.getFieldProps("cod")}
        />
        <Input
          label="Nº NOTA FISCAL"
          {...formikFilter.getFieldProps("documentNumber")}
        />
      </GroupInput>

      {!is_client && (
        <GroupInput>
          <Input
            label="CÓDIGO CLIENTE"
            {...formikFilter.getFieldProps("codClient")}
          />
          <Input label="CNPJ" {...formikFilter.getFieldProps("cnpj")} />
          <Input
            label="RAZÃO SOCIAL"
            {...formikFilter.getFieldProps("company_name")}
          />
        </GroupInput>
      )}

      <GroupInput>
        <Select
          label="CÓD. VENDEDOR"
          data={
            filtersData?.sellers?.map((seller) => ({
              name: `${String(seller?.id)} ${String(seller?.name)}`,
              value: String(seller?.id),
            })) ?? []
          }
          {...formikFilter.getFieldProps("codSeller")}
        />
      </GroupInput>

      <GroupInput>
        <InputCheckboxV2
          label="SITUAÇÃO"
          name="status"
          data={
            filtersData?.status?.map((item) => ({
              description: item.name,
              value: item.id.toString(),
            })) ?? []
          }
          checks={formikFilter?.values?.status ?? []}
          height="9rem"
          onChange={(e) => {
            formikFilter.setFieldValue("status", e);
          }}
          error={
            formikFilter.touched.status && formikFilter.errors.status
              ? formikFilter.errors.status.toString()
              : undefined
          }
          readonly={tab === "Faturados"}
        />
        <InputCheckboxV2
          label="SITUAÇÃO ITEM"
          name="statusItem"
          data={
            filtersData?.statusItem?.map((item) => ({
              description: item.name,
              value: item.id.toString(),
            })) ?? []
          }
          checks={formikFilter?.values?.statusItem ?? []}
          height="9rem"
          onChange={(e) => {
            formikFilter.setFieldValue("statusItem", e);
          }}
          error={
            formikFilter.touched.statusItem && formikFilter.errors.statusItem
              ? formikFilter.errors.statusItem.toString()
              : undefined
          }
          readonly={tab === "Faturados"}
        />

        {!is_client && (
          <InputCheckboxV2
            label="SCORE DO CLIENTE"
            name="scores"
            data={
              filtersData?.scores?.map((item) => ({
                description: item.name,
                value: item.id.toString(),
              })) ?? []
            }
            checks={formikFilter?.values?.scores ?? []}
            height="9rem"
            onChange={(e) => {
              formikFilter.setFieldValue("scores", e);
            }}
            error={
              formikFilter.touched.scores && formikFilter.errors.scores
                ? formikFilter.errors.scores.toString()
                : undefined
            }
            readonly={tab === "Faturados"}
          />
        )}
      </GroupInput>

      <GroupInput>
        <Select
          label="MARCA"
          data={
            filtersData?.brands?.map((brand) => ({
              name: String(brand.name),
              value: String(brand.id),
            })) ?? []
          }
          {...formikFilter.getFieldProps("brand")}
        />
        <Select
          label="TIPO"
          data={[
            { name: "Venda Futura", value: "venda futura" },
            { name: "Pronta Entrega", value: "pronta entrega" },
          ]}
          {...formikFilter.getFieldProps("type")}
        />
      </GroupInput>

      <GroupInput>
        {!is_client && (filtersData?.canceled.length ?? 0) > 0 && (
          <Select
            label="MOTIVO CANCELAMENTO"
            data={filtersData?.canceled?.map((item) => ({
              name: String(item.name),
              value: String(item.id),
            }))}
            {...formikFilter.getFieldProps("canceled")}
          />
        )}
        {!is_client && (filtersData?.rejection.length ?? 0) > 0 && (
          <Select
            label="MOTIVO RECUSA"
            data={filtersData?.rejection?.map((item) => ({
              name: String(item.name),
              value: String(item.id),
            }))}
            {...formikFilter.getFieldProps("rejection")}
          />
        )}
      </GroupInput>

      {/* {filterOptions?.highlighters && filterOptions?.highlighters.length > 0 && (
          <Select
            label="Destacador"
            data={
              filterOptions?.highlighters?.map((item) => ({
                name: item.name,
                value: item.name,
              })) ?? []
            }
            {...formikFilter.getFieldProps("highlighter")}
          />
        )}
    */}

      <Select
        label="DATA DO PEDIDO"
        data={[
          { name: "Predefinida", value: 1 },
          { name: "Específica", value: 2 },
          { name: "Intervalo", value: 3 },
        ]}
        {...formikFilter.getFieldProps("orderPeriod")}
      />

      {Number(formikFilter.values.orderPeriod) === 1 && (
        <Select
          label="DATA DO PEDIDO"
          data={[
            { name: "Hoje", value: 0 },
            { name: "Ontem", value: 1 },
            { name: "Últimos 7 dias", value: 7 },
            { name: "Últimos 15 dias", value: 15 },
            { name: "Últimos 30 dias", value: 30 },
          ]}
          {...formikFilter.getFieldProps("orderPresetDate")}
          error={
            formikFilter.touched.orderPresetDate &&
            formikFilter.errors.orderPresetDate
              ? formikFilter.errors.orderPresetDate
              : undefined
          }
        />
      )}
      {Number(formikFilter.values.orderPeriod) === 2 && (
        <Input
          type="date"
          label="DATA DO PEDIDO"
          {...formikFilter.getFieldProps("orderSpecificDate")}
          error={
            formikFilter.touched.orderSpecificDate &&
            formikFilter.errors.orderSpecificDate
              ? formikFilter.errors.orderSpecificDate
              : undefined
          }
        />
      )}

      {Number(formikFilter.values.orderPeriod) === 3 && (
        <GroupInput>
          <Input
            type="date"
            label="DATA INICIAL"
            {...formikFilter.getFieldProps("orderStartDate")}
            error={
              formikFilter.touched.orderStartDate &&
              formikFilter.errors.orderStartDate
                ? formikFilter.errors.orderStartDate
                : undefined
            }
          />
          <Input
            type="date"
            label="DATA FINAL"
            {...formikFilter.getFieldProps("orderEndDate")}
            error={
              formikFilter.touched.orderEndDate &&
              formikFilter.errors.orderEndDate
                ? formikFilter.errors.orderEndDate
                : undefined
            }
          />
        </GroupInput>
      )}

      <Select
        label="DATA DE FATURAMENTO"
        data={[
          { name: "Predefinida", value: 1 },
          { name: "Específica", value: 2 },
          { name: "Intervalo", value: 3 },
        ]}
        {...formikFilter.getFieldProps("billingOrderPeriod")}
      />

      {Number(formikFilter.values.billingOrderPeriod) === 1 && (
        <Select
          label="DATA DO PEDIDO"
          data={[
            { name: "Hoje", value: 0 },
            { name: "Ontem", value: 1 },
            { name: "Últimos 7 dias", value: 7 },
            { name: "Últimos 15 dias", value: 15 },
            { name: "Últimos 30 dias", value: 30 },
          ]}
          {...formikFilter.getFieldProps("billingOrderPresetDate")}
          error={
            formikFilter.touched.billingOrderPresetDate &&
            formikFilter.errors.billingOrderPresetDate
              ? formikFilter.errors.billingOrderPresetDate
              : undefined
          }
        />
      )}
      {Number(formikFilter.values.billingOrderPeriod) === 2 && (
        <Input
          type="date"
          label="DATA DO PEDIDO"
          {...formikFilter.getFieldProps("billingOrderSpecificDate")}
          error={
            formikFilter.touched.billingOrderSpecificDate &&
            formikFilter.errors.billingOrderSpecificDate
              ? formikFilter.errors.billingOrderSpecificDate
              : undefined
          }
        />
      )}
      {Number(formikFilter.values.billingOrderPeriod) === 3 && (
        <GroupInput>
          <Input
            type="date"
            label="DATA INICIAL"
            {...formikFilter.getFieldProps("billingOrderStartDate")}
            error={
              formikFilter.touched.billingOrderStartDate &&
              formikFilter.errors.billingOrderStartDate
                ? formikFilter.errors.billingOrderStartDate
                : undefined
            }
          />
          <Input
            type="date"
            label="DATA FINAL"
            {...formikFilter.getFieldProps("billingOrderEndDate")}
            error={
              formikFilter.touched.billingOrderEndDate &&
              formikFilter.errors.billingOrderEndDate
                ? formikFilter.errors.billingOrderEndDate
                : undefined
            }
          />
        </GroupInput>
      )}
    </PanelFilter>
  );
};
